import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const CollectionsPickerMobileContainer = styled(FlexContainer)`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid ${COLOR.LIGHTGREY};
  box-sizing: border-box;
  margin: 0 24px;
  padding: 14px 16px 14px 14px;
  cursor: pointer;
  position: relative;
  z-index: 40;
  font-size: 16px;
  ${TYPOGRAPHY.BOLD}

  @media only screen and (min-width:1200px) {
    display: none;
  }
`;

export const CollectionsPickerMobileTitle = styled.div`
  display: inline-block;
  max-width: 88%;
`;
